export function validationMessage(errorName: string | null): string | null {
  switch (errorName) {
    case 'required':
      return 'Это поле обязательно для заполнения';
    case 'email':
      return 'Введите корректный адрес электронной почты';
    case 'minlength':
      return 'Минимальная длина не достигнута';
    case 'maxlength':
      return 'Достигнута максимальная допустимая длина';
    case 'pattern':
      return 'Неверный формат данных';
    case 'fileType':
      return 'Неподдерживаемый тип файла';
    case 'passwordMismatch':
      return 'Пароли не совпадают';
    case 'invalidDate':
      return 'Неверный формат даты';
    case 'dateOutOfRange':
      return 'Дата вне допустимого диапазона';
    case 'invalidEmail':
      return 'Введите корректный адрес электронной почты'
    default:
      return null;
  }
}
